'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _PersistentMediaPlayer = require('./PersistentMediaPlayer');

var _PersistentMediaPlayer2 = _interopRequireDefault(_PersistentMediaPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PersistentMediaPlayer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PersistentMediaPlayer/index.js
// module id = 628
// module chunks = 11